export const getBoundsOrCenterFromGeo = (geojson) => {
    if (geojson.type === 'Point') {
        return {
            lat: geojson.coordinates[1],
            lng: geojson.coordinates[0],
        }
    }

    var minLng = geojson.coordinates[0][0][0];
    var maxLng = geojson.coordinates[0][0][0];
    var minLat = geojson.coordinates[0][0][1];
    var maxLat = geojson.coordinates[0][0][1];

    for (let i = 0; i < geojson.coordinates[0].length; i += 1) {
        minLat = Math.min(minLat, geojson.coordinates[0][i][1]);
        maxLat = Math.max(maxLat, geojson.coordinates[0][i][1]);

        minLng = Math.min(minLng, geojson.coordinates[0][i][0]);
        maxLng = Math.max(maxLng, geojson.coordinates[0][i][0]);
    }

    return {
        northeast: {
            lat: maxLat + 0.0005,
            lng: maxLng + 0.0005,
        },
        southwest: {
            lat: minLat - 0.0005,
            lng: minLng - 0.0005,
        }
    }
}


// WEBPACK FOOTER //
// ./src/shared/helpers/geojson.js